// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"battery-charging"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.5 6H1V18H5M15 6H20V18H14M23 14V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 5.5L7 12H13L9 18.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BatteryChargingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'battery-charging',
    ref,
    icon: element,
  },
));

BatteryChargingIcon.displayName = 'BatteryChargingIcon';

export default BatteryChargingIcon;
